import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { popupState } from "@recoil/componentState";
import { useRecoilValue, useSetRecoilState } from "recoil";
const CommonPopup = () => {
    const { isOpen, dimm, content } = useRecoilValue(popupState);
    const { closePopup } = usePopup(); // 팝업 닫기 함수 사용
    return (isOpen && (_jsxs(_Fragment, { children: [content, dimm && _jsx("div", { className: "dimm", style: { display: "block", zIndex: "30" } })] })));
};
export default CommonPopup;
export const usePopup = () => {
    const setPopup = useSetRecoilState(popupState);
    // 팝업을 여는 함수
    const openPopup = (content, onClose = null) => {
        document.body.style.overflowY = "hidden";
        setPopup({
            isOpen: true,
            dimm: true,
            content: content,
            onCloseCallback: onClose,
        });
    };
    const openInnerPopup = (content, onClose = null) => {
        setPopup({
            isOpen: true,
            dimm: false,
            content: content,
            onCloseCallback: onClose,
        });
    };
    // 팝업을 닫는 함수
    const closePopup = () => {
        document.body.style.overflowY = "";
        setPopup((prev) => {
            // 팝업이 닫힐 때 등록된 콜백 함수가 있다면 실행
            if (prev.onCloseCallback) {
                prev.onCloseCallback();
            }
            // 팝업 상태 초기화
            return {
                isOpen: false,
                dimm: false,
                content: null,
                onCloseCallback: null,
            };
        });
    };
    return { openPopup, openInnerPopup, closePopup };
};
